import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { webapi } from '../../shared/my-constants';

@Injectable()
export class EmgPatientListService {
    private headers = new Headers({ 'Content-Type': 'application/json' });
    private getEmgPatientListUrl = webapi + 'emg_patient_list/list?';
    // private getEmgPatientUrl = webapi + 'emg_patient_list/getEmergecyPatientById/'; by rohan
    private getEmgPatientUrl = webapi + 'emg_patient_list/getpatientbyid/';
    private getEmgPatient1 = webapi + 'emg_patient_list/getEmergecyPatientById/';
    private getBasepath = webapi + 'mst_patient/getbasepath/';
    private getEmgPatientBillListUrl = webapi + 'tbill_bill/billSearchByUnitId/';
    private updateEmgPatient = webapi + 'emg_patient_list/update';
    private checkIsAlreadyInEmgPatient = webapi + 'emg_patient_list/checkIsAlreadyInEmgPatient/';


    constructor(private http: Http) {
    }

    getEmgPatientList(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http
            .get(this.getEmgPatientListUrl + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
    }

    getEmgPatient(visitId: any): Observable<any> {
        return this.http
            .get(this.getEmgPatientUrl + visitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getEmgPatientBillList(json: any): Observable<any> {
        return this.http.post(this.getEmgPatientBillListUrl, JSON.stringify(json), { headers: this.headers })
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    gatbasepath() {
        return this.http.get(this.getBasepath)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }

    editEmgPatient(model: any) {
        return this.http.put(this.updateEmgPatient, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    private logError(error: Response | any) {
        return Observable.throw(error.message || error);
    }

    checkIsEmgPatient(patientId: any) {
        return this.http.get(this.checkIsAlreadyInEmgPatient + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
 getEmgPatientObj(eplId: any) {
        return this.http.get(this.getEmgPatient1 + eplId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emergency/emg-patient-list/emg-patient-list.service.ts